<template>
    <section class="o-page-bottom-spacing">
        <page-header>
            <slot slot="title">{{ $t('new_preorder.header') }}</slot>
            <slot slot="description">
                <p>{{$t('new_preorder.header_description')}}</p>
            </slot>
        </page-header>
        <div class="o-wrapper o-wrapper--center">
            <form action="" class="c-form c-form--horizontal">
                <div style="color: red; font-weight: bold; margin-bottom: 10px;"
                     v-if="Validate.model" v-for="(error, index) in Validate.model" :key="index">
                    <slot name="error">{{ error }}</slot>
                </div>
                <div class="u-max-700 c-form-row">
                    <v-form-row>
                        <v-custom-select v-model="selectedCustomer"
                                         :options="CustomerOptions"
                                         option-name="Name"
                                         option-value="Name"
                                         :error="Validate.CustomerKey"
                                         name="customer"
                                         search-label="Name"
                                         track-by="AltKey"
                                         @change="setCustomer"
                                         @search-change="onSearchChange"
                                         :isLoading="customerIsLoading"
                                         :internalSearch="false"
                                         :fluid="true" :multiple="false"
                                         option-tag="AltKey">
                            <slot slot="label">{{ $t('new_preorder.customer') }}</slot>
                        </v-custom-select>
                    </v-form-row>

                    <v-form-row>
                        <v-custom-select v-model="selectedSheet"
                                         :options="TargetOptions"
                                         option-name="TargetName"
                                         option-value="TargetId"
                                         name="sheet"
                                         search-label="TargetName"
                                         track-by="TargetId"
                                         :error="Validate.SheetId"
                                         :fluid="true"
                                         :multiple="false"
                                         @change="updateMaxDiscount">
                            <slot slot="label">{{ $t('new_preorder.preorder_list') }}</slot>
                        </v-custom-select>
                    </v-form-row>

                    <v-form-row>
                        <v-input v-model="PreOrder.InternalCustomerReference" name="customer_reference" :fluid="true"
                                 :error="Validate.InternalCustomerReference" :maxlength=20>
                            <slot slot="label">{{ $t('new_preorder.internal_reference') }}</slot>
                        </v-input>
                    </v-form-row>

                    <v-form-row>
                        <v-input v-model="PreOrder.OrderReference" name="order_reference" :fluid="true"
                                 :error="Validate.OrderReference" :maxlength=60>
                            <slot slot="label">{{ $t('new_preorder.order_reference') }}</slot>
                        </v-input>
                    </v-form-row>

                    <v-form-row>
                        <v-user-select v-show="PreOrder.CustomerKey"
                                            v-model="PreOrder.Users"
                                            :error="Validate.Users"
                                            :customerKey="PreOrder.CustomerKey" >
                            <slot slot="label">{{ $t('new_preorder.notify_users') }}</slot>
                        </v-user-select>
                    </v-form-row>

                    <v-form-row>
                        <v-switch v-model="PreOrder.ForecastsAndHistoryVisible" :name="`forecast_${_uid.toString()}`">
                            <slot slot="label">{{ $t('new_preorder.show_history_forecasts') }}</slot>
                        </v-switch>
                    </v-form-row>

                    <v-form-row>
                        <v-input v-model.number="PreOrder.PreOrderDiscount" name="preorder_discount" type="number"
                                 :min=0 :max=MaxDiscount :error="Validate.PreOrderDiscount">
                            <slot slot="label">{{ $t('new_preorder.preorder_discount') }}</slot>
                            <slot slot="suffix">% <template v-if="selectedSheet && selectedSheet.MaximumDiscount">(Max {{ selectedSheet.MaximumDiscount }}%)</template></slot>
                        </v-input>
                    </v-form-row>

                    <v-form-row v-if="PreOrder.CustomerKey">
                        <v-address-select v-show="PreOrder.CustomerKey"
                                          v-model="PreOrder.Address"
                                          :error="Validate.Address"
                                          :customerKey="PreOrder.CustomerKey">
                            <slot slot="label">{{ $t('new_preorder.delivery_address') }}</slot>
                        </v-address-select>
                    </v-form-row>

                    <v-form-row>
                        <div class="c-form-item c-form-item--horizontal">
                            <v-label></v-label>
                            <button :disabled="isSubmitted" @click="submitForm" class="c-button c-button--alpha">{{ $t('global.next') }}</button>
                        </div>
                    </v-form-row>
                </div>
            </form>
        </div>
    </section>
</template>

<script>
    import debounce from 'lodash/debounce'
    import PageHeader from '@/components/common/PageHeader'

    // Forms
    import VTextarea from '@/components/form/Textarea'
    import VInput from '@/components/form/Input'
    import VSelect from '@/components/form/Select'
    import VCustomSelect from '@/components/form/CustomSelect'
    import VFormRow from '@/components/form/Row'
    import VLabel from '@/components/form/Label'
    import VDatepicker from '@/components/form/Datepicker'
    import VTargetListSelect from '@/components/form/targetList/TargetListSelect'
    import VAddressSelect from '@/components/form/addressSelect/AddressSelect'
    import VUserSelect from '@/components/form/userSelect/UserSelect'
    import VSwitch from '@/components/form/Switch'
    import VError from '@/components/form/Error.vue'

    // Store
    import {mapGetters} from 'vuex'

    export default {
        components: {
            PageHeader,
            VTextarea,
            VSelect,
            VCustomSelect,
            VLabel,
            VInput,
            VFormRow,
            VDatepicker,
            VTargetListSelect,
            VAddressSelect,
            VUserSelect,
            VSwitch,
            VError
        },
        data () {
            return {
                PreOrder: {
                    Id: "00000000-0000-0000-0000-000000000000",
                    CustomerKey: this.$route.params.customerKey ? this.$route.params.customerKey : 0,
                    SheetId: this.$route.params.id ? this.$route.params.id : undefined,
                    InternalCustomerReference: undefined,
                    OrderReference: undefined,
                    Users: [],
                    ForecastsAndHistoryVisible: false,
                    PreOrderDiscount: 0,
                    Address: {}
                },
                Validate: {},
                isSubmitted: false,
                customerIsLoading: false
            }
        },
        computed: {
            ...mapGetters({
                TargetSelected: 'TargetSelected',
                TargetOptions: 'TargetOptions',
                CustomerOptions: 'CustomerOptions',
                CustomerUsersOptions: 'CustomerUsersOptions',
            }),
            selectedSheet: {
                get () {
                    let output;
                    // output = this.TargetOptions.find((obj) => { return obj.TargetId === this.$route.params.SheetId; });
                    output = this.TargetOptions.find((obj) => {
                        return obj.TargetId === this.PreOrder.SheetId;
                    });

                    if (output) {
                        this.$set(this.PreOrder, 'SheetId', output.TargetId);
                    }

                    return output ? output : {};
                },
                set (value) {
                    this.$set(this.PreOrder, 'SheetId', value.TargetId);
                    return value;
                }
            },
            selectedCustomer: {
                get () {
                    let output;
                    // output = this.CustomerOptions.find((obj) => { return obj.Id === this.$route.params.customerKey; });
                    output = this.CustomerOptions.find((obj) => {
                        return obj.Id === this.PreOrder.CustomerKey;
                    });

                    if (output) {
                        this.$set(this.PreOrder, 'CustomerKey', output.Id);
                    }

                    return output ? output : {};
                },
                set (value) {
                    this.$set(this.PreOrder, 'CustomerKey', value.Id);
                    return value;
                }
            },
            MaxDiscount() {
                if(this.selectedSheet && this.selectedSheet.MaximumDiscount) {
                    return this.selectedSheet.MaximumDiscount;
                } else {
                    return 0;
                }
            }
        },
        created: function () {
            this.$store.dispatch('getCustomerOptions');
            this.$store.dispatch('getTargetOptions');
        },
        methods: {
            validateForm (response) {
                let errors = response.data.ModelState;
                let output = {};

                // Get error data from server, and transform to vue data
                Object.keys(errors).forEach(function (key) {
                    if (key === 'model') {
                        output[key] = errors[key];
                    } else {
                        key = key.replace('model.', {});
                        output[key] = errors['model.' + key][0];
                    }
                });

                this.Validate = output;
            },
            setCustomer() {
                this.$set(this.PreOrder, 'Address', {});
            },
            onSearchChange: debounce(function (searchTerm) {
                this.customerIsLoading = true;

                let params = {};

                if(String(searchTerm).length > 0){
                    params.search = searchTerm;
                }

                this.$store.dispatch('getCustomerOptions', { params: params}).then(() => {
                    this.customerIsLoading = false;
                });
            }, 300),
            submitForm (e) {
                this.isSubmitted = true;
                this.$store.dispatch('createPreOrder', this.PreOrder).then((response) => {
                    if (response.status > 300) {
                        this.validateForm(response);
                        this.isSubmitted = false;
                    } else {
                        this.$router.push({
                            name: 'SalesmanPreOrdersEdit',
                            params: {id: response}
                        });
                        this.isSubmitted = false;
                    }
                });
                e.preventDefault();
            },
            updateMaxDiscount() {
                if(this.selectedSheet.MaximumDiscount < this.PreOrder.PreOrderDiscount)
                {
                    this.PreOrder.PreOrderDiscount = this.selectedSheet.MaximumDiscount;
                }
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/salesman/preOrders/Create.vue